var map = {
	"./produktbroschuren_be.png": "0633",
	"./produktbroschuren_ch.png": "0655",
	"./produktbroschuren_de.png": "6ebb",
	"./produktbroschuren_fr.png": "31ab",
	"./produktbroschuren_it.png": "2fc5",
	"./produktbroschuren_nl.png": "9f07"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6474";